"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButton = exports.PrimaryButton = exports.Button = exports.BaseButton = void 0;

var _polished = require("polished");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseButton = _styledComponents.default.button.attrs({
  type: 'button'
}).withConfig({
  displayName: "Button__BaseButton",
  componentId: "sc-1eobygi-0"
})(["box-sizing:border-box;height:calc(2em + 2px);padding:0.375em 0.75em;border-color:", ";border-style:solid;border-width:1px;border-radius:0.5em;background-color:", ";color:", ";cursor:pointer;font-size:1em;line-height:1.25;outline:none;user-select:none;&:active,&:hover{background-color:", ";}&:disabled{background-color:", ";cursor:not-allowed;}&:focus{box-shadow:", ";}svg{position:relative;top:0.11em;width:0.9em;height:0.9em;}"], function (props) {
  return props.borderColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
}, function (props) {
  return (0, _polished.darken)(0.15, props.backgroundColor);
}, function (props) {
  return (0, _polished.transparentize)(0.5, props.backgroundColor);
}, function (props) {
  return "0 0 0 0.2em ".concat((0, _polished.transparentize)(0.5, props.borderColor));
});
/* stylelint-disable block-no-empty */


exports.BaseButton = BaseButton;
var Button = (0, _styledComponents.default)(BaseButton).attrs({
  backgroundColor: '#f8f9fa',
  borderColor: '#6c757d'
}).withConfig({
  displayName: "Button",
  componentId: "sc-1eobygi-1"
})([""]);
exports.Button = Button;
var PrimaryButton = (0, _styledComponents.default)(BaseButton).attrs({
  backgroundColor: '#428bca',
  borderColor: '#428bca',
  textColor: '#fff'
}).withConfig({
  displayName: "Button__PrimaryButton",
  componentId: "sc-1eobygi-2"
})([""]);
/* stylelint-enable block-no-empty */

exports.PrimaryButton = PrimaryButton;

var TextButton = _styledComponents.default.button.attrs({
  type: 'button'
}).withConfig({
  displayName: "Button__TextButton",
  componentId: "sc-1eobygi-3"
})(["padding:0;border:none;background:none;color:#428bca;cursor:pointer;font-size:1em;outline:none;user-select:none;&:active,&:hover{color:#be4248;}&:disabled{color:", ";cursor:not-allowed;}&:focus{text-decoration:underline;}"], (0, _polished.transparentize)(0.5, '#428bca'));

exports.TextButton = TextButton;